import { transposeTable } from '../../../shared/utils/transposeTable.ts';
import { PreviewTable } from './types.ts';


export function createRecordsTable(
    previewTable: PreviewTable,
    options?: { quotesAroundPosNr?: boolean, commaDecimals?: boolean }
): string[][] {
    function setDecimalsIf(values: string[]): string[] {
        if (!options?.commaDecimals) return values;
        return values.map(it => it.replace('.', ','));
    }

    const headerRow = [
        'Position',
        ...(options?.quotesAroundPosNr
            ? previewTable.positionNumbers.map(it => `"${it}"`)
            : previewTable.positionNumbers
        )
    ];
    const nominalsRow = ['Nominal', ...setDecimalsIf(previewTable.nominalValues)];
    const upperTolerancesRow = ['Upper tolerance', ...setDecimalsIf(previewTable.upperTolerances)];
    const lowerTolerancesRow = ['Lower tolerance', ...setDecimalsIf(previewTable.lowerTolerances)];
    const gaugesRow = ['Gauge', ...setDecimalsIf(previewTable.gauges)];

    const valueRows = [];
    for (const recordRow of previewTable.recordRows) {
        if (!recordRow.includeInReport) continue;

        const row = [recordRow.partCount.toString()];
        for (const value of recordRow.values) {
            row.push(value.value);
        }
        valueRows.push(setDecimalsIf(row));
    }

    const table = [headerRow, nominalsRow, upperTolerancesRow, lowerTolerancesRow, gaugesRow, ...valueRows];
    const transposed = transposeTable(table);
    return transposed;
}
